<template>
  <div
    v-loading="loading"
    class="csv-uploader relative"
  >
    <!-- Some required props uses fake values just to fulfill required values
      (could not find a way in vue2 to config conditional params: allow organizationId:null if not importable) -->
    <AppFileImport
      file-types=".CSV"
      mime-types=".csv"
      :file-params="fileInfo"
      :organization-id="0"
      :template-url="templateUrl"
      resource-type="client"
      :show-label="false"
      :import-file="false"
      @upload-file="processFile"
      @remove-file="fileInfo = {}"
    />
    <div
      v-if="response"
      class="small mt-5"
    >
      <div
        v-if="!errors.length"
        class="csv-members dialog-warning orange mb-5"
      >
        <span>
          <i class="hi hi-warning text-orange mr-5" />
          {{ validMembersNumber }} {{ $filters.pluralize(validMembersNumber, 'member', 'members') }} will be added.
        </span>
      </div>
      <div
        v-if="errors.length"
        class="dialog-warning csv-errors mb-5"
      >
        <span>
          <i class="hi hi-warning text-danger mr-5" />
          {{ errorsList }}
        </span>
      </div>
      <div
        v-if="invalidMembersNumber"
        class="csv-result dialog-warning"
      >
        <span>
          <i class="hi hi-warning text-danger mr-5" />
          Unable to import {{ invalidMembersNumber }} {{ $filters.pluralize(invalidMembersNumber, 'member', 'members') }}.
          <a
            :href="invalidEmailsUrl"
            download="invalid-emails"
          >
            Download the CSV
          </a>
          with members’ emails for review and re-upload the original file.
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { MEMBERS_EMAIL_FILE_IMPORT_TEMPLATE_URL } from '~/app_constants';

export default {
  name: 'MembersCsvUploader',
  props: {
    uploader: {
      type: Function,
      required: true,
    },
    changed: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      errors: [],
      response: null,
      fileInfo: {},
    };
  },
  computed: {
    invalidEmailsUrl() {
      const csv = this.response.invalid_emails
        .map((item) => [item])
        .map((fields) => fields.join(','))
        .join('\n');

      return encodeURI('data:text/csv;charset=utf-8,' + csv);
    },
    templateUrl() {
      return MEMBERS_EMAIL_FILE_IMPORT_TEMPLATE_URL;
    },
    invalidMembersNumber() {
      return this.response.invalid_emails.length;
    },
    validMembersNumber() {
      return this.response.user_ids.length;
    },
    errorsList() {
      return this.errors.join('. ');
    },
  },
  methods: {
    async processFile(file) {
      const form = new FormData();

      this.fileInfo = { id: file.name, metadata: { filename: file.name } };
      this.loading = true;
      this.resetValues();
      form.append('csv_file', file);
      try {
        // Expects { user_ids: [1,2], invalid_emails: ['sample@email.com'], errors: [] }
        this.response = await this.uploader(form);
      } catch (e) {
        // some error occurred on server side
        console.error('Uploader error', e);
        this.response = { errors: ['There was an error processing your import. Please check the file and try again.'] };
      }
      this.loading = false;
      this.parseResponse();
    },
    parseResponse() {
      this.response = { ...{ invalid_emails: [], user_ids: [] }, ...this.response };
      if (this.response.errors?.length) {
        this.errors = this.response.errors;
      } else {
        this.changed(this.response.user_ids);
        if (!this.response.user_ids.length) {
          this.errors.push(`No members to be added.`);
        }
      }
    },
    resetValues() {
      this.errors = [];
      this.response = null;
    },
  },
};
</script>
